import { clearEmptyErrors } from '@shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { required } from '@shared/lib/validation/validateRequired/required';
import { CreateFormFields } from '../../../ui/modal-create-feedback/types';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { FeedbackMigrateCodes } from '@shared/model/feedback';
import { CreateFormKeys } from '@features/feedback/create-feedback-request/config/form-constants';
import { maxLength } from '@shared/lib/validation/validateMaxLength/max-length';

export const validate = (fields: CreateFormFields) => {
    const { validateField, errors } = validateForm();
    const subject = (fields[CreateFormKeys.Subject] || [])[0];

    if (subject && subject.value === FeedbackMigrateCodes.Orders) {
        validateField({
            name: CreateFormKeys.Order,
            message: required(fields[CreateFormKeys.Order]),
        });
    }

    if (subject && subject.value === FeedbackMigrateCodes.Products) {
        validateField({
            name: CreateFormKeys.Product,
            message: required(fields[CreateFormKeys.Product]),
        });
    }

    validateField({
        name: CreateFormKeys.Message,
        message: required(fields[CreateFormKeys.Message]),
    });

    validateField({
        name: CreateFormKeys.Message,
        message: maxLength(fields[CreateFormKeys.Message], 255),
    });
    return clearEmptyErrors(errors);
};
